<template>
  <span>
    <img width="20" src="info-icon.png" alt="How this works" style="cursor: pointer" @click="show = true"/>
    <b-modal v-model="show" title="Failure Recipients By Booking Base" ok-only>
      <p>A base listed here gets its {{ subject }} instead of the {{ fieldLabel }} above. Enter each base name as it appears on the booking. One row can cover several names, separated by commas.</p>
      <p v-if="tenantType === 'CM'" data-platform="CM">
        <b>Coach Manager:</b> we match the booking's <b>Booking Base</b> field (<code>BookingBase</code> in the booking export). Coach Manager can cut long base names to 10 characters, so add the shortened name to the row too.
      </p>
      <p v-else-if="tenantType === 'TBN'" data-platform="TBN">
        <b>TBN:</b> we match the booking's start base (<code>FirstStartBase</code>): where the trip leaves from, usually your yard name, exactly as it appears in TBN. Trips that start somewhere other than a listed name go to the {{ fieldLabel }} above.
      </p>
      <p v-else data-platform="other">
        Your booking platform doesn't send a base with each trip, so {{ subject }} always go to the {{ fieldLabel }} above.
      </p>
      <p class="mb-0">Capitalization doesn't matter, but the whole name has to match.</p>
    </b-modal>
  </span>
</template>

<script>
// FI-2241: info modal for the <failure field>_by_booking_base lists
export default {
  name: 'FailureByBaseHelp',
  props: {
    fieldLabel: { type: String, required: true },
    subject: { type: String, default: 'failures' },
    tenantType: { type: String, default: '' },
  },
  data() {
    return { show: false }
  },
}
</script>
